// isStepValid / firstInvalidStep の実体はここに置く。useInvestmentStyleDiagnosisForm.ts 本体は
// useSendAppEvent 経由で capacitor 連携の重い依存を持つため、判定ロジックだけを純粋関数として切り出し、
// テストから capacitor 等をモックせずに直接検証できるようにする（investmentStyleDiagnosisStorage.ts と同じ狙い）。
import { ANXIETY_ROWS } from "@/constants/investmentStyleDiagnosisQuestions";
import type { Answers } from "@/types/investmentStyleDiagnosis";

// index は画面の順番（0〜11）。自由記述は任意のため判定に含めない。
export const isAnswersStepValid = (answers: Answers, index: number): boolean => {
  switch (index) {
    case 0:
      return answers.purposes.length > 0 && answers.primary_purpose !== null;
    case 1:
      return answers.interest.length === 3;
    case 2:
      return answers.success_conditions.length > 0;
    case 3:
      return answers.monthly_out_of_pocket !== null;
    case 4:
      return answers.holding_period !== null;
    case 5:
      return answers.location_yield_preference !== null;
    case 6:
      return answers.management_style !== null;
    case 7:
      return answers.short_term_sale_intent !== null;
    case 8:
      return answers.meeting_check_items.length > 0;
    case 9:
      return answers.explanation_styles.length > 0;
    case 10:
      return ANXIETY_ROWS.every((row) => answers.anxiety[row.key] !== undefined);
    case 11:
      return answers.avoid_sales_styles.length > 0;
    default:
      return false;
  }
};

// 0 〜 upToExclusive-1 の中で最初に isAnswersStepValid を満たさない step を返す。全て有効なら null。
// 「今いるstepより前が全部validか」を求める共通ヘルパーで、フック内の継続的ガード（前段への強制差し戻し）と
// 送信直前の最終検証（DiagnosisInvestmentStylePage.handleNext）の両方から使う。ロジックの重複を避けるため
// このファイルに一本化している。
export const firstInvalidStepInAnswers = (answers: Answers, upToExclusive: number): number | null => {
  for (let index = 0; index < upToExclusive; index += 1) {
    if (!isAnswersStepValid(answers, index)) return index;
  }
  return null;
};
